import { FC } from 'react';
import { Translate } from 'next-translate';
import useTranslation from 'next-translate/useTranslation';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { CardOpportunityProps } from '../../interface/secondaries';
import { termFromToday } from '@/utils/date';
import { formatNumberToPTBRCurrency, formatToPercentage } from '@/utils/format';
import { MapRender } from '@/utils/jsx';
export const InfoDetailsOpportunity: FC<InfoDetailsOpportunityProps> = ({
  data
}) => {
  const {
    t: i18n
  } = useTranslation('common');
  const dataInfo: DataInfo[] = generateDataList(data, i18n);
  return <Flex direction="column" w="full" gap="xl" data-sentry-element="Flex" data-sentry-component="InfoDetailsOpportunity" data-sentry-source-file="index.tsx">
      <Flex direction="column" gap="xs" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Text size="xl" fontWeight="semibold" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {data?.subject}
        </Text>
        <Text size="xl" color="content.tertiary" noOfLines={2} data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {data?.description}
        </Text>
      </Flex>

      <Text size="xl" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
        {i18n('attributes.infos')}
      </Text>

      <Flex direction="column" gap="m" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <MapRender items={dataInfo} render={({
        label,
        value,
        hidden
      }, idx) => {
        if (hidden) return <></>;
        return <Flex key={idx} justifyContent="space-between" alignItems="center" borderBottom="1px solid" borderColor="transparency.mid" pt="xs" pb="l">
                <Text size="l" fontWeight="semibold" color="content.secondary">
                  {label}
                </Text>
                <Text size="l" textAlign="right" color="content.tertiary">
                  {value}
                </Text>
              </Flex>;
      }} data-sentry-element="MapRender" data-sentry-source-file="index.tsx" />
      </Flex>

      <Button data-testId="invest-button" variant="solid" w="full" h="2.75rem" onClick={() => null} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        {i18n('attributes.invest')}
      </Button>
    </Flex>;
};
interface InfoDetailsOpportunityProps {
  data: CardOpportunityProps;
}
interface DataInfo {
  label: string;
  value: string;
  hidden?: boolean | undefined;
}
const generateDataList = (data: CardOpportunityProps, i18n: Translate) => {
  return [{
    label: i18n('screens.secondariesOpportunities.drawers.details.labelsInfo.label01'),
    value: formatNumberToPTBRCurrency(Number(data?.available_amount)) ?? '--',
    hiden: !data?.available_amount
  }, {
    label: i18n('screens.secondariesOpportunities.drawers.details.labelsInfo.label02'),
    value: formatNumberToPTBRCurrency(Number(data?.unit_price)) ?? '--'
  }, {
    label: i18n('screens.secondariesOpportunities.drawers.details.labelsInfo.label03'),
    value: formatToPercentage(Number(data?.spread), 2) ?? '--',
    hidden: true
  }, {
    label: i18n('screens.secondariesOpportunities.drawers.details.labelsInfo.label04'),
    value: data?.strategy ?? '--',
    hidden: !data?.strategy
  }, {
    label: i18n('screens.secondariesOpportunities.drawers.details.labelsInfo.label05'),
    value: termFromToday(data?.due_date ?? '') ?? '--'
  }, {
    label: i18n('screens.secondariesOpportunities.drawers.details.labelsInfo.label06'),
    value: data?.extendable ?? '--',
    hidden: true
  }, {
    label: i18n('screens.secondariesOpportunities.drawers.details.labelsInfo.label07'),
    value: data?.yield ?? '--',
    hidden: !data?.yield
  }];
};